<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-28 14:37:05
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-08-22 09:30:37
 * @Description: 轮播图
 -->
<template>
  <div class="swiper-wrapper">
    <swiper :options="swiperOption" class="swiper" ref="mySwiper">
      <swiper-slide class="slide-item">
        <img src="https://files.jinr.com/jinr-index/img/swiper-02.png" alt="" srcset="" />
      </swiper-slide>
      <!-- <swiper-slide class="slide-item">
        <img src="https://files.jinr.com/jinr-index/img/mid-tab-03.png" alt="" srcset="" />
      </swiper-slide>
      <swiper-slide class="slide-item">
        <img src="https://files.jinr.com/jinr-index/img/mid-tab-02.png" alt="" srcset="" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div> -->
    </swiper>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  name: 'SwiperWrapper',
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
    // imgList() {
    //   let arr = [];
    //   for (let i = 1; i < 2; i++) {
    //     const index = i < 10 ? `0${i}` : i;
    //     arr.push(require(`https://files.jinr.com/jinr-index/img/swiper-${index}.png`));
    //   }
    //   return arr;
    // }
  },
  data() {
    return {
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        autoplay: {
          delay: 3000
        },
        loop: true,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          // type: 'custom',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        },
        on: {
          click: function() {
            this.autoplay.start();
          }
        }
      }
    };
  }
};
</script>
<style lang="less">
.swiper {
  width: 100%;
  .slide-item {
    width: 100%;
    background: #f0f0f0;
    text-align: center;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
  }
  .my-bullet {
    display: inline-block;
    width: 40px;
    height: 6px;
    background: rgba(255, 255, 255, 0.4);
    margin: 10px 16px;
    cursor: pointer;
  }
  .my-bullet-active {
    background: rgba(255, 255, 255, 0.4);
    // background: #fff;
    // animation: identifier 3s linear infinite;
    position: relative;
    // width: 134px;
    &::before {
      content: '';
      position: absolute;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 1;
      background: #fff;
      animation: identifier 3s linear forwards;
    }
  }
}

@keyframes identifier {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
</style>

<style lang="less" scoped></style>
